import type { L10n } from "../lib/locales"

// Profile link: https://itseslam.com/en/about/
// User-supplied Arabic bio and CEO message; English adapted for the bilingual website.
export const leadership = {
  name: { en: "Eslam Mohamed", ar: "إسلام محمد" },
  role: { en: "Chief Executive Officer", ar: "المدير التنفيذي" },
  profileUrl: "https://itseslam.com/en/about/",
  bio: {
    en: "I am an Egyptian software developer and entrepreneur. Since 2012, I have been building digital products and systems and turning ideas into practical solutions.",
    ar: "مطوّر برمجيات ورائد أعمال مصري، منذ عام 2012، أعمل على بناء المنتجات والأنظمة الرقمية وتحويل الأفكار إلى حلول عملية.",
  },
  heading: {
    en: "The right path, beyond the fastest.",
    ar: "المسار الأنسب، لا الأسرع فحسب.",
  },
  message: [
    {
      en: "When the Industrial Revolution began, the change went beyond the arrival of new machines and technologies. It also transformed how people worked, how businesses were managed, and how the world was built.",
      ar: "عندما بدأت الثورة الصناعية، لم يكن التغيير مجرد ظهور آلات وتقنيات جديدة، بل تغيّرت معها الطريقة التي يعمل بها الناس، وتُدار بها الأعمال، ويُبنى بها العالم.",
    },
    {
      en: "I believe we are living through a similar moment today, perhaps at a much faster pace.",
      ar: "أعتقد أننا نعيش اليوم مرحلة مشابهة، وربما بوتيرة أسرع بكثير.",
    },
    {
      en: "The digital world is no longer separate from our everyday reality; it has become an essential part of it. With rapid progress and an ever-growing range of tools, technologies, and solutions, the real challenge is no longer gaining access to technology. It is understanding what we actually need from it, and which path we can rely on today and continue along tomorrow.",
      ar: "العالم الرقمي لم يعد عالمًا موازيًا لواقعنا، بل أصبح جزءًا أساسيًا منه. ومع هذا التطور المتسارع، وتعدد الأدوات والتقنيات والحلول، أصبح التحدي الحقيقي ليس في الوصول إلى التكنولوجيا، بل في معرفة ما نحتاجه منها فعلًا، وأي مسار يمكننا الاعتماد عليه اليوم والاستمرار فيه غدًا.",
    },
    {
      en: "This is where the idea for Orkest began.",
      ar: "من هنا جاءت فكرة أوركست.",
      emphasis: true,
    },
    {
      en: "We started Orkest to be a partner that helps businesses make better technology decisions, choose solutions that fit their real needs, and build systems that can grow and evolve.",
      ar: "بدأنا أوركست لنكون شريكًا يساعد الأعمال على اتخاذ قرارات تقنية أفضل، واختيار الحلول التي تناسب احتياجاتها الحقيقية، وبناء أنظمة قادرة على النمو والتطور.",
    },
    {
      en: "We believe the fastest path is not always the best. The true value of technology lies in the impact it has, the problems it solves, and the opportunities it opens up, rather than how new or complex it is.",
      ar: "نحن نؤمن أن الطريق الأسرع ليس دائمًا هو الأفضل، وأن القيمة الحقيقية للتكنولوجيا لا تكمن في حداثتها أو تعقيدها، بل في الأثر الذي تتركه، والمشكلات التي تحلها، والفرص التي تفتحها.",
    },
    {
      en: "No one knows for certain what the business world will look like in ten years. But we believe the future will not necessarily be built with the tools we use today. It will be built through our ability to make the right decisions and keep pace with change.",
      ar: "لا أحد يعرف على وجه اليقين كيف سيبدو عالم الأعمال بعد عشر سنوات، لكننا نؤمن أن المستقبل لن يُبنى بالضرورة بالأدوات التي نستخدمها اليوم، بل بقدرتنا على اتخاذ القرارات الصحيحة ومواكبة التغيير.",
    },
    {
      en: "That is why we built Orkest: to help our partners choose their path with confidence, and to take part in building the future rather than simply watching it change.",
      ar: "ولهذا بنينا أوركست؛ لنساعد شركاءنا على اختيار طريقهم بثقة، ولنكون جزءًا من بناء المستقبل، لا مجرد متفرجين على تغيراته.",
      emphasis: true,
    },
  ],
} satisfies {
  name: L10n
  role: L10n
  profileUrl: string
  bio: L10n
  heading: L10n
  message: (L10n & { emphasis?: boolean })[]
}
